<div class="loader-wrapper-{{type}}">
  <span class="loader"></span>
</div>
